import React from 'react'

import { CreateSurvey } from './components/CreateSurvey'

export const CreateSurveyPage = () => <CreateSurvey />
